import { pubSub } from '@utils/PubSub';
export default class Cart {
  constructor() {
    document.addEventListener('theme:add-to-cart', async (e) => {
      const item = e.detail;
      const hasGiftKey = item?.properties ? Object.keys(item.properties).includes('_isGiftCard') : false;
      const isGiftCard = hasGiftKey ? JSON.parse(item?.properties?._isGiftCard) : false;
      const itemInCart = await this.itemPresentInCart(item);
      const urgencySet = JSON.parse(sessionStorage.getItem('urgencySet')) ?? false;
      const urgencyEnabled = JSON.parse(sessionStorage.getItem('urgencyEnabled')) ?? false;
      const notRemoving = item.quantity > 0;

      if (!urgencySet && urgencyEnabled && notRemoving) {
        this.emitUrgencyEvent();
      }

      if (itemInCart && !isGiftCard) {
        this.updateCart(item);
      } else {
        this.addToCart(item);
      }
    });
    document.addEventListener('theme:clear-cart', (e) => {
      this.clearCart();
    });
  }

  async getCartResponse() {
    const cart = await fetch('/cart.json');
    return cart.json();
  }

  async itemPresentInCart(payload) {
    const { items } = await this.getCartResponse();
    const matches = this.findCartItem(payload, items);
    return matches.length > 0;
  }

  findCartItem(payload, cartItems) {
    return cartItems.filter((item) => {
      const hasMatchingId = item.id.toString() === payload.id;
      const hasMatchingKey = item.key === payload.id;
      return hasMatchingId || hasMatchingKey;
    });
  }

  emitFetch() {
    return pubSub.publish('cart:request');
  }

  emitUrgencyEvent() {
    const now = new Date();
    sessionStorage.setItem('urgencySet', true);
    sessionStorage.setItem('urgencyStart', now);
    pubSub.publish('cart:urgency:start');
  }

  addToCart(formData) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json();
      })
      .then(() => {
        fetch('/cart.js')
          .then((response) => {
            return response.json();
          })
          .then((cart) => {
            this.updateCartIconQuantities(cart);
            this.emitFetch();
          });
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  async updateCart(payload) {
    const request = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    };

    const response = await fetch('/cart/change.js', request).then((res) => res.json());

    this.updateCartIconQuantities(response);
    this.emitFetch();
  }

  clearCart() {
    fetch(window.Shopify.routes.root + 'cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        this.updateCartIconQuantities();
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  updateCartIconQuantities(cart?: { items? }) {
    let itemCount = 0;
    if (cart?.items) {
      cart.items.forEach((item) => {
        const included = !item?.properties?._freeGift;
        if (included) itemCount = itemCount + item.quantity;
      });
    }

    document.querySelectorAll('.header__icon--cart').forEach((icon) => {
      itemCount > 0 ? icon.querySelector('svg').classList.add('cart-populated') : icon.querySelector('svg').classList.remove('cart-populated');
      icon.querySelector('.cart-count-bubble').setAttribute('data-cart-size', `${itemCount}`);
      icon.querySelector('span[aria-hidden="true"]').innerHTML = `${itemCount}`;
    });
  }
}
